(function () {
    angular.module('directives')
        .directive('hHomeAccessPortalButton', [function() {
            return {
                restrict: 'E',
                templateUrl: '../hmodules/directives/h-home-access-portal-button/h-home-access-portal-button.directive.html',
            };
        }]);
})();